export default "__VITE_ASSET__e688a927__"